define('models/parts/menu/save-button',[
    'underscore',
    'backbone',
    // src
    'utils',
    'services/api',
    'services/i18n',
], function(_, Backbone, U, API, i18n) {

    var MSaveButton = Backbone.Model.extend({
        defaults: {
            id: 'btn-save-action',
            title: i18n.t('messages:tooltip-save-button'),
            itemClass: "pull-right",
            btnClass: "btn-tc-custom",
            disabled: true,
            callback: _.noop
        },
    });

    // Return the model for the module
    return MSaveButton;
});

